import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v128c-35.299 0-64-28.701-64-64s28.591-64 64-64Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.476 91.666a38.654 38.654 0 0 1-6.324-1.383l-21.956 8.782 8.782-15.37C33.062 78.164 29 69.974 29 61.455 29 44.635 45.709 31 66.326 31s37.326 13.635 37.326 30.454",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.522 99.065c0 18.839 21.956 32.935 41.717 24.152l17.565 6.587-6.587-13.174c5.687-4.545 8.783-10.561 8.783-17.565 0-13.854-13.767-26.348-30.74-26.348-16.972 0-30.738 12.494-30.738 26.348Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
};

var Memo = /*#__PURE__*/memo(SvgComments);

export { Memo as default };
//# sourceMappingURL=comments.svg.js.map
